module.exports = __webpack_public_path__ + "img/2.e38d053f.jpg";